const formatMoney = (window.BB && window.BB.formatMoney)
  ? window.BB.formatMoney.bind(window.BB)
  : (cents) => '$' + (cents / 100).toFixed(2);

const init = (root) => {
  if (root.dataset.variantReady) return;
  root.dataset.variantReady = '1';

  const sectionId = root.dataset.sectionId;

  const dataNode = root.querySelector('[data-product-variants]');
  if (!dataNode) return;

  let variants = [];
  try {
    variants = JSON.parse(dataNode.textContent.trim());
  } catch (e) {
    return;
  }

  let inventoryMap = {};
  try {
    const invNode = root.querySelector('[data-product-inventory]');
    if (invNode) inventoryMap = JSON.parse(invNode.textContent.trim());
  } catch (e) {}

  const fieldsets = Array.from(root.querySelectorAll('[data-option-index]'));

  const getSelected = () => fieldsets.map((fs) => {
    const checked = fs.querySelector('[data-option-input]:checked');
    return checked ? checked.value : null;
  });

  const findVariant = (selected) =>
    variants.find((v) => {
      const opts = [v.option1, v.option2, v.option3];
      return selected.every((val, i) => val === null || opts[i] === val);
    });

  const updateAvailability = (selected) => {
    fieldsets.forEach((fs, i) => {
      const inputs = fs.querySelectorAll('[data-option-input]');
      inputs.forEach((input) => {
        const trial = selected.slice();
        trial[i] = input.value;
        const match = variants.find((v) => {
          const opts = [v.option1, v.option2, v.option3];
          return trial.every((val, j) => val === null || opts[j] === val);
        });
        input.disabled = !match || !match.available;
      });
    });
  };

  const updateLabel = (fs) => {
    const checked = fs.querySelector('[data-option-input]:checked');
    const label = fs.querySelector('[data-option-selected]');
    if (label && checked) label.textContent = checked.value;
  };

  const apply = () => {
    const selected = getSelected();
    fieldsets.forEach(updateLabel);
    updateAvailability(selected);

    const variant = findVariant(selected);
    if (!variant) return;

    const form = document.querySelector(`[data-product-form][data-section-id="${sectionId}"]`);
    if (form) {
      const idInput = form.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;
      const btn = form.querySelector('[data-add-to-cart]');
      const btnLabel = form.querySelector('[data-add-to-cart-label]');
      if (btn) btn.disabled = !variant.available;
      if (btnLabel) {
        const labelAdd = form.dataset.labelAdd || 'Add to cart';
        const labelPreorder = form.dataset.labelPreorder || 'Preorder';
        const labelSoldOut = form.dataset.labelSoldOut || 'Sold out';
        const isPreorder = form.dataset.preorder === 'true';
        if (!variant.available) btnLabel.textContent = labelSoldOut;
        else if (isPreorder) btnLabel.textContent = labelPreorder;
        else btnLabel.textContent = labelAdd;
      }

      const qtyInput = form.querySelector('[data-qty-input]');
      if (qtyInput) {
        const inv = inventoryMap[variant.id];
        const tracks = variant.inventory_management && inv && inv.policy === 'deny';
        const cap = tracks && inv.qty > 0 ? inv.qty : null;
        if (cap !== null) qtyInput.max = String(cap);
        else qtyInput.removeAttribute('max');
        if (window.BB && window.BB.syncQtyStepper) window.BB.syncQtyStepper(qtyInput);
      }
    }

    const stockNode = document.getElementById(`stock-${sectionId}`);
    if (stockNode) {
      const inv = inventoryMap[variant.id];
      const tracks = variant.inventory_management && inv && inv.policy === 'deny';
      const showStock = tracks && variant.available && inv.qty > 0;
      if (showStock) {
        stockNode.textContent = inv.qty + ' available';
        stockNode.classList.remove('hidden');
        const low = inv.qty <= 5;
        stockNode.classList.toggle('text-red-600', low);
        stockNode.classList.toggle('font-medium', low);
        stockNode.classList.toggle('text-mocha-700', !low);
      } else {
        stockNode.textContent = '';
        stockNode.classList.add('hidden');
      }
    }

    const priceNode = document.getElementById(`price-${sectionId}`);
    if (priceNode) {
      while (priceNode.firstChild) priceNode.removeChild(priceNode.firstChild);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (onSale) {
        const s = document.createElement('s');
        s.className = 'not-italic font-normal text-sm text-mocha-700';
        s.textContent = formatMoney(variant.compare_at_price);
        priceNode.appendChild(s);
      }
      const priceSpan = document.createElement('span');
      priceSpan.className = onSale
        ? 'italic text-red-600 midnight:text-red-400 text-xl font-semibold'
        : 'text-xl font-semibold';
      priceSpan.textContent = formatMoney(variant.price);
      priceNode.appendChild(priceSpan);
      if (!variant.available) {
        const soldOut = document.createElement('span');
        soldOut.className = 'text-sm text-mocha-700 italic';
        soldOut.textContent = 'Sold out';
        priceNode.appendChild(soldOut);
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: { sectionId, variantId: variant.id, variant },
    }));
  };

  root.addEventListener('change', (e) => {
    if (e.target.matches('[data-option-input]')) apply();
  });

  apply();
};

document.querySelectorAll('[data-variant-picker]').forEach(init);
